var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildingtag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#F2F5F9",
    stroke: "#E5EBF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 25.8333H28.1667V27.5H9.83337V25.8333H11.5V13.3333C11.5 13.1123 11.5878 12.9004 11.7441 12.7441C11.9004 12.5878 12.1124 12.5 12.3334 12.5H20.6667C20.8877 12.5 21.0997 12.5878 21.256 12.7441C21.4122 12.9004 21.5 13.1123 21.5 13.3333V25.8333H24.8334V19.1667H23.1667V17.5H25.6667C25.8877 17.5 26.0997 17.5878 26.256 17.7441C26.4122 17.9004 26.5 18.1123 26.5 18.3333V25.8333ZM13.1667 14.1667V25.8333H19.8334V14.1667H13.1667ZM14.8334 19.1667H18.1667V20.8333H14.8334V19.1667ZM14.8334 15.8333H18.1667V17.5H14.8334V15.8333Z",
    fill: "#003C8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingtag);
export default __webpack_public_path__ + "static/media/buildingtag.f4fe9b045510ccefd60293a3296c7f7b.svg";
export { ForwardRef as ReactComponent };